import { Container, Image } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { FC } from 'react'

type RCPOBannerProps = {
  title: string
  image: AssetsElement
}

export const RCPOBanner: FC<RCPOBannerProps> = ({ title, image }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <Link href={t('rcpo.selection.url', { ns: 'navigation' })}>
        <a className="relative flex w-full items-center px-4 py-12 md:mt-6 md:px-12 md:py-20 xl:py-24">
          <Image
            sources={[
              getKontentImage(image.value[0].url, { width: 768 }),
              getKontentImage(image.value[0].url, { width: 1200 }),
              getKontentImage(image.value[0].url, { width: 1500 }),
            ]}
            alt={image.value[0].description || title}
            className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center"
            placeholder={getKontentImage(image.value[0].url, { width: 10 })}
          />
          <Heading
            variant="h1"
            as="h2"
            className="relative z-[2] mb-0 whitespace-pre-line text-white"
          >
            {title}
          </Heading>
        </a>
      </Link>
    </Container>
  )
}
